import { Select, SelectProps } from "antd";
import { FormaValorTaxa } from "core/features/area-comum/enums";
import SelectBaseAntd from "../SelectBaseAntd";

const { Option } = Select;

export interface SelectFormaValorTaxaProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
}

function SelectFormaValorTaxa({
  value,
  isInvalid,
  onChange,
  ...rest
}: SelectFormaValorTaxaProps) {
  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        {...rest}
      >
        <Option value={FormaValorTaxa.ValorFixo} key={FormaValorTaxa.ValorFixo}>
          Um valor fixo
        </Option>
        <Option
          value={FormaValorTaxa.ValorVariavel}
          key={FormaValorTaxa.ValorVariavel}
        >
          Valores variáveis em relação aos dias
        </Option>
      </SelectBaseAntd>
    </>
  );
}

export default SelectFormaValorTaxa;
